<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-2 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
        <div class="col-md-2" >
          <b-form-group  label="" label-for="datepicker-2" autocomplete="off" style = "margin-bottom: 0px;" >
            <b-form-datepicker id="datepicker-2" v-model= "FromDate" @input="getShipments()" placeholder="Choose Start Date"
               :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" local="en">
               </b-form-datepicker>
          </b-form-group>
        </div>
         <div class="col-md-2">
          <b-form-group  label="" style = "margin-bottom: 0px;" label-for="datepicker-1" autocomplete="off">
            <b-form-datepicker id="datepicker-1" v-model= "ToDate" placeholder="Choose End Date" @input="getShipments()" 
              :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" local="en">
              </b-form-datepicker>
          </b-form-group>
        </div>
        <!--==========Class dropdown============-->
      
      <div class="col-md-2">
        <b-form-select v-model="IsInventory" :options="inventoryOptions" class = "class-dropdown"  @change="getShipments()"></b-form-select>
      </div>

        <!---SEARCH BOX-->
      <div class="col-md-3">
        <div class="searchbox input-group" role="group">
        <input class="form-control search-box my-search-box" type="text" placeholder=" Search By Voucher No" aria-label="search" v-model="filteredText">
        
        <button class="search-button btn btn-primary filter"  @click="getShipments()"><i class="fa fa-search search-icon"></i></button>
        </div> 
      </div>

      <div class="col-md-1 Add-button" style="text-align:center">
        <a href="javascript:void(0)">
          <div class="AddButton">
            <div class="icon">
              <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
              </i>
            </div>
            <div data-text="Add" class="name add-btn" v-b-modal.AddShipmentGovtModal>Add </div>
          </div>
        </a>
      </div> 

    </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless table-center-sdk cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
                <th role="columnheader">Shipment Date</th>
            
                <th role = "columnheader">Voucher No </th>
                 <!-- <th role = "columnheader">Inventory</th>  -->
                <th role = "columnheader">Depot</th>
                <th role = "columnheader">Product Type (No Of Sacks)</th> 
                <th role="columnheader" >Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "shipments==null" >
                <td class= "center-td" colspan="11">No Data</td>
              </tr>
              
            <tr v-else v-for="ship in shipments" :key=ship.id>
              <td  role="cell">
               
                  {{ship.shipmentDate| moment("MMMM Do YYYY")}}
              
              </td>
             
              <td>{{ship.voucherNo}}</td>
              <!-- <td>{{ship.isInventoryTransaction ? 'Yes':'No'}}</td> -->
              <td>{{ship.depo}}</td>
              <td>
                <div v-for="details in ship.flourDetails" :key=details.id>
                <b>{{details.noOfSacks}}</b> sacks of <b>{{details.bagWeight}}</b> kg {{details.flourTypeName}}  
                </div>
                </td>
              <td>
               
                <span  @click= "passRecordToEdit(ship)">
                <i role="button" title ="Edit" style="color:green" class="far fa-edit"></i> 
                </span>
                <span @click= "passRecordToDelete(ship.voucherNo)">
                   &nbsp;|&nbsp;<i role="button" title ="Delete" style="color:green" class="far fa-trash-alt"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getShipments()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <AddShipmentGovtModal/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "shipToDelete"/>
    <EditShipmentGovtModal  :shipmentToEdit = "shipToEdit"/>
    <Toaster ref ="toaster"/>
  
  
  
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner';
import AddShipmentGovtModal from './modals/AddShipmentGovtModal';
import DeleteModal from '../../modals/DeleteModal';
import EditShipmentGovtModal from './modals/EditShipmentGovtModal';
import Toaster from '../toaster'
export default {
    name: 'ShipmentsGovt',
    data(){
        return{
          moduleName:'Shipments (Govt)',
       
          
          isLoading:false,
          shipToEdit :  null,
          shipToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
    
           inventoryOptions:
          [
            { value: false, text: 'Non Inventory' },
            { value: true, text: ' Inventory' },
            { value: null, text: 'All' },
          ],
         
         
          shipments:null,
        
          ToDate: new Date(),
          FromDate: new Date(),
          IsInventory:null,
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
        
		}
  },
 
methods:{
    getPage(page)
  {
    this.page = page;
    this.getShipments();
  },
  
  passRecordToDelete(id)
  {
    this.shipToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "shipment/Delete/";
    this.deleteModalHeading = "Delete";
    this.$bvModal.show('DeleteModal');

  },
  passRecordToEdit(ship)
  {
    this.shipToEdit = ship;
    setTimeout(
      () => {
    this.$bvModal.show('EditShipmentGovtModal')
  },150)
    
    
    // console.log(this.companyToEdit)
  },
    getShipments(){
      this.isLoading = true;
  
      axios.post('/shipment/getall',{"FromDate":this.FromDate,
      "ToDate":this.ToDate,"CompanyId":this.$auth.user().companyId,
      "IsInventory":this.IsInventory,"IsGovt":true,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      // console.log(res)
      this.isLoading = false;
     if(res.data.status == 1)
     {
      this.shipments=res.data.data;
      this.rows = res.data.totalRecords;
     }
    else if(res.data.status== -1)
    {
        this.$refs.toaster.showToast('Error','danger',res.data.msg)
    }
    else
    {
      this.shipments = null;
    }
   
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getShipments();
  }
  },
	created(){
   
     this.FromDate = new Date(this.FromDate.getFullYear(), this.FromDate.getMonth(), 1,this.FromDate.getHours())
    // console.log(this.ToDate)
    this.ToDate = new Date (this.ToDate.getFullYear(), this.ToDate.getMonth() + 1, 0,this.ToDate.getHours());
    // console.log(this.ToDate)
   this.getShipments();
  },
  components:{
    Spinner,
    AddShipmentGovtModal,
    DeleteModal,
    EditShipmentGovtModal,
    Toaster

   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>